import React, { Dispatch, useMemo } from "react";
import SearchField from "./SearchField";
import { Actions, FinderState } from "./finderReducer";
import AddSearchField from "./AddSearchField";
import { QueryClause } from "lib/api/types";

type Props = Pick<FinderState, "searchFields" | "activeSearchFields"> & {
	dispatch: Dispatch<Actions>;
	querySummary?: string[];
	query?: QueryClause;
};

function QueryByForm({
	activeSearchFields,
	searchFields,
	dispatch,
	querySummary,
	query,
}: Props) {
	// Create a map of inactive search fields to
	// be passed down
	const inactiveFields = useMemo(
		() =>
			Object.keys(searchFields)
				.filter(v => !activeSearchFields.includes(v))
				.map(v => searchFields[v]),
		[activeSearchFields, searchFields]
	);

	const renderFields = useMemo(() => {
		const searchFieldCount = Object.keys(searchFields).length;

		const f = activeSearchFields.map((f, i) => (
			<SearchField
				index={i}
				removeable={activeSearchFields.length > 1}
				key={`searchField-${searchFields[f]?.name}`}
				dispatch={dispatch}
				{...searchFields[f]}
				searchFieldOptions={inactiveFields}
				queryValue={
					querySummary !== undefined && querySummary.length > 0
						? querySummary[i]
						: undefined
				}
				queryOpts={
					query !== undefined && query.length > 0
						? query[i]
						: undefined
				}
			/>
		));
		if (activeSearchFields.length < searchFieldCount)
			f.push(
				<AddSearchField
					dispatch={dispatch}
					key={`searchField-${activeSearchFields.length}`}
					searchFieldOptions={inactiveFields}
				/>
			);

		return f;
	}, [
		activeSearchFields,
		dispatch,
		inactiveFields,
		query,
		querySummary,
		searchFields,
	]);

	return <>{renderFields}</>;
}

export default QueryByForm;
